import {axios as http} from "@/plugins/http"

export default class Api {
    static telegramSave(query) {
        return http.post("/api/v1/post/telegram/save", query)
    }

    static siteSalesSave(query) {
        return http.post("/api/v1/post/site/sales/save", query)
    }

    static siteArticlesSave(query) {
        return http.post("/api/v1/post/site/articles/save", query)
    }
    static siteNotesSave(query) {
        return http.post("/api/v1/post/site/notes/save", query)
    }

    static sitePromocodeSave(query) {
        return http.post("/api/v1/post/site/promocode/save", query)
    }

    static erid(postId, erid) {
        return http.post("/api/v1/post/mark-ad-custom/erid", {
            "post_id": postId,
            "erid": erid,
        }).then((resp) => {
            return resp.data
        })
    }
}
